import { Button, styled } from '@mui/material';

const StyledButton = styled(Button)({
    textTransform: 'none',
});

export default StyledButton;
